import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const programLevelsFilter: QueryParameterSchema<'programLevels'> = {
  getDefaultValue: () => [],
  getValue: ({ parameters }) => parameters.programLevels,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    programLevels: (urlSearchParams.get('filter[programLevels]') || '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[programLevels]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (!value || value.length === 0) return {};
    return { 'filter[programLevelIds]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { programLevels },
    } = staticProps;
    return { programLevels: value.filter((s) => !!s && !!programLevels[s]?.name) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { programLevels },
    },
  }) => {
    return value.map((programLevel) => ({
      filterKey: 'programLevels',
      key: programLevel,
      label: `${programLevels[programLevel]?.name}`,
      value: programLevel,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { programLevels: value.filter((item) => item !== removedValue) };
  },
};
